import { render, staticRenderFns } from "./Letterhead.vue?vue&type=template&id=7f21713e&scoped=true&"
import script from "./Letterhead.vue?vue&type=script&lang=js&"
export * from "./Letterhead.vue?vue&type=script&lang=js&"
import style0 from "./Letterhead.vue?vue&type=style&index=0&id=7f21713e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21713e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VImg,VSheet,VSkeletonLoader})
